import { useTranslation } from "@/language/translation";

export interface SQDCNamedConfiguration {
  nameId?: number | null;
  uniqueName: string;
}

export function resolveSQDCDisplayName(
  configuration: SQDCNamedConfiguration,
  locale: string,
  translationExists: (key: string, locale: string) => boolean,
  translate: (key: string) => string,
): string {
  if (configuration.nameId == null) return configuration.uniqueName;

  const key = `dynamic.${configuration.nameId}`;
  return translationExists(key, locale) ? translate(key) : configuration.uniqueName;
}

export function useSQDCDisplayName() {
  const { locale, t, te } = useTranslation();

  return (configuration: SQDCNamedConfiguration) =>
    resolveSQDCDisplayName(configuration, locale.value, te, (key) => String(t(key)));
}
